<template>
  <section v-if="contextData">
    <div class="container-wrap py-9 tablet:py-12">
      <h2 class="text-solution-h2 mb-2 tablet:line-clamp-2">
        {{ contextData.title }}
      </h2>
      <p
        class="mb-6 text-sm text-gray-600 tablet:mb-8 tablet:line-clamp-4 tablet:text-base desktop:mb-6 desktop:w-2/3"
      >
        {{ contextData.description }}
      </p>

      <ul v-if="!isTablet" class="column-311">
        <li v-for="item in contextItems" :key="hash(item)">
          <SuiteListIconFeatureCard
            :item-data="item"
            :is-expand="isExpand"
            :url-connector="urlConnector"
          />
        </li>
      </ul>

      <div v-if="isDesktop" class="mt-9 flex items-center py-3">
        <div class="h-[1px] w-[calc((100%-180px)/2)] bg-gray-400" />

        <TheButton
          class="flex w-[180px] items-center justify-center text-blue-400"
          type="outline"
          :title="isExpand ? 'Collapse' : 'Expand'"
          @click="handleCollapse"
        >
          <span class="block w-20 text-sm font-bold">
            {{ isExpand ? 'Collapse' : 'Expand' }}
          </span>
          <IconCaret :direction="isExpand ? 'up' : 'down'" class="h-5 w-5" />
        </TheButton>

        <div class="h-[1px] w-[calc((100%-180px)/2)] bg-gray-400" />
      </div>

      <CarouselProgressbar
        v-if="isTablet"
        :carousel-list="contextItems"
        :slides-per-view="2"
      >
        <template #card="{ item }">
          <SuiteListIconFeatureCard
            :item-data="item"
            :is-expand="isExpand"
            :url-connector="urlConnector"
          />
        </template>
      </CarouselProgressbar>
    </div>
  </section>
</template>

<script setup lang="ts">
  import hash from 'object-hash';

  import type { ISuiteProps } from '@/components/Shared/Suite/type.ts';

  interface ILink {
    name: string;
    description: string;
    link: string;
    trackingCode?: string;
  }

  interface IItem {
    name: string;
    description?: string;
    thumbnail: string;
    links: ILink[];
  }

  interface IListIconFeatureData {
    title: string;
    description?: string;
    items: IItem[];
  }

  interface IListIconFeature {
    component: 'list-icon-feature';
    meta: {
      navigable?: string;
    };
    data: IListIconFeatureData;
  }

  type IProps = ISuiteProps<IListIconFeature>;

  const props = defineProps<IProps>();

  const { isDesktop, isTablet } = useScreen();

  const isExpand = ref<boolean>(false);

  const contextData = computed(
    (): IListIconFeatureData => props.suiteData.data
  );

  const contextItems = computed((): IItem[] => contextData.value.items);

  const handleCollapse = (): void => {
    isExpand.value = !isExpand.value;
  };

  export type { IItem, ILink, IListIconFeature, IListIconFeatureData };
</script>
